/* eslint-disable react/prop-types */
import { Tooltip as AntdTooltip } from 'antd';
import cn from 'clsx';
import React from 'react';
import classes from './Tooltip.module.scss';

const ATooltip = ({ className = '', white, dark, ...other }) => {
  return (
    <AntdTooltip
      {...other}
      className={cn(classes.wrapper, className)}
      overlayClassName={cn(classes.overlay, other.overlayClassName, {
        [classes.isWhite]: !!white,
        [classes.isDark]: !!dark,
      })}
    />
  );
};

export default ATooltip;
